import Vue from 'vue'
import api from '@/services/api'
import { createInspectionManager, inspectionIdentity } from './manager'
import { configureRightsPreviewTransport } from '@/services/rightsPreviewTransport'

let tabStorage = null
try { tabStorage = typeof window === 'undefined' ? null : window.sessionStorage } catch (_) { /* Optional persistence. */ }

export const rightsInspection = createInspectionManager({
  reactive: value => Vue.observable(value), set: Vue.set, storage: tabStorage,
  request: body => api.post('/engine/rights-inspection/evaluate', body, { timeout: 20000 }),
})
configureRightsPreviewTransport({ getContext: () => rightsInspection.state })

export function installRightsInspection(store) {
  store.watch((state, getters) => inspectionIdentity(getters.currentUser, getters.isAuth),
    identity => rightsInspection.setIdentity(identity), { immediate: true })
}

export const loadInspectionOptions = () => api.get('/engine/rights-inspection/options', { timeout: 20000 })
